var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"companyRank"},[_vm._v(" companyRank ")])
}
var staticRenderFns = []

export { render, staticRenderFns }